import React from "react";
import { Avatar, List, Stack, Toolbar, Drawer, IconButton, Typography, Box, ButtonBase } from "@mui/material";
import sizeConfigs from "../../../configs/sizeConfigs";
import colorConfigs from "../../../configs/colorConfigs";
import { PATH_NAME } from "../../../configs/pathName";
import assets from "../../../assets";
import appRoutes from "../../../routes/appRoutes";
import SideBarItem from "./SideBarItem";
import { useAppDispatch } from "../../../redux/features/redux-hooks";
import { useNavigate } from "react-router-dom";
import { logout } from "../../../redux/features/Auth/AuthThunk";
// import { useCart } from "../../../context/CartContext";
import { typo } from "../../../assets/fonts/font";
import CustomButton from "../Button/CustomButton";
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import { getCurrentBrand } from "../../../configs/brandConfigs";

interface SideBarProps {
  mobileOpen: boolean;
  handleDrawerToggle: () => void;
}

const SideBar: React.FC<SideBarProps> = ({
  mobileOpen,
  handleDrawerToggle,
}) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const brand = getCurrentBrand();
  // const { clearCart } = useCart();

  const handleLogout = async () => {
    try {
      await dispatch(logout()).unwrap();
      // clearCart();
      navigate(PATH_NAME.LOGIN);
    } catch (e) {
      console.error(e);
    }
  };

  const handleBacktoHome = async () => {
    navigate("/");
  };

  const drawer = (
    <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
      <List disablePadding>
        <Toolbar sx={{ marginBottom: "40px" }}>
          <Stack sx={{ width: "100%" }} direction="row" justifyContent="center">
            <Avatar
              src={assets.images.logo_white}
              sx={{
                width: "150px",
                height: "auto",
                borderRadius: "0px",
                paddingTop: "40px",
              }}
            />
          </Stack>
        </Toolbar>
        <CustomButton
          fullWidth
          buttonType="secondary"
          onClick={handleBacktoHome}
          sx={{ ...typo.button, padding: 1, margin: 2, width: "85%" }}
        >
          {brand?.id === "shake-salad" ? "Back to ShakeSalad" : "Back to nomzy.club"}
        </CustomButton>
        {appRoutes.map((route, index) =>
          route.sidebarProps ? <SideBarItem item={route} key={index} /> : null
        )}
      </List>
      <ButtonBase
        focusRipple
        onClick={handleLogout}
        sx={{
          ...typo.bodyContent,
          color: colorConfigs.secondary,
          display: "flex",
          alignItems: "center",
          justifyContent: "left",
          mt: "auto",
          px: 2,
          pt: 1,
          pb: 1,
          gap: "20px",
          "&:hover": {
            backgroundColor: colorConfigs.tertiary,
          },
        }}
      >
        {/* <IconButton edge="end" color="inherit" aria-label="logout"> */}
          <ExitToAppIcon />
        {/* </IconButton> */}
        <Typography
          variant="body1"
          sx={{
            ...typo.sideBar,
            color: colorConfigs.secondary,
            display: "flex",
            alignItems: "center",
            justifyContent: "left",
            mt: "auto",
            px: 2,
            pt: 1,
            pb: 1,
            gap: "20px",
            "&:hover": {
              backgroundColor: colorConfigs.tertiary,
            },
          }}>
          Logout
        </Typography>
      </ButtonBase>
    </Box>
  );

  return (
    <nav>
      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
        sx={{
          display: { xs: "block", sm: "none" },
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            width: sizeConfigs.sidebar.width,
            backgroundColor: colorConfigs.primary,
            color: colorConfigs.secondary,
          },
        }}
      >
        {drawer}
      </Drawer>
      <Drawer
        variant="permanent"
        sx={{
          display: { xs: "none", sm: "block" },
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            width: sizeConfigs.sidebar.width,
            backgroundColor: colorConfigs.primary,
            color: colorConfigs.secondary,
          },
        }}
        open
      >
        {drawer}
      </Drawer>
    </nav>
  );
};

export default SideBar;
